/* eslint-disable @typescript-eslint/no-empty-function */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function noop(..._options: any[]): any {}
